<template>
    <section class="founder-thoughts scroll-show">
        <div class="founder-thoughts__container">
            <article class="founder-thoughts__block">
                <div class="founder-thoughts__content scroll-show-block">
                    <span class="founder-thoughts__tag uppercase">
                        {{ 'founder_thoughts' | staticTitle }}
                    </span>
                    <div class="founder-thoughts__divider"></div>
                    <vue-marked>{{ 'founder_thoughts' | staticContent }}</vue-marked>
                </div>
                <div class="founder-thoughts-signature-holder scroll-show-block">
                    <img class="founder-thoughts-signature" :src="'seo-signature.png' | assetsImg" alt="SEO Signature">
                    <vue-marked>{{ 'founder_thoughts' | staticContentAlt }}</vue-marked>
                </div>
            </article>
        </div>
    </section>
</template>
<script>
export default {
    name: 'FounderThoughts',
    methods: {
        UI_UX() {
            try {
                const root = document.querySelector(".founder-thoughts.scroll-show");
                if (!root) return;
                const blocks = root.querySelectorAll(".scroll-show-block");
                blocks.forEach((block, index) => {
                    block.style.transitionDelay = `${index * 150}ms`;
                });
                const observer = new IntersectionObserver((entries, obs) => {
                    entries.forEach(entry => {
                        if (!entry.isIntersecting) return;
                        entry.target.classList.add("in-view");
                        obs.unobserve(entry.target);
                    });
                }, {
                    threshold: .15
                });
                blocks.forEach(block => observer.observe(block));
            } catch (e) {
                console.error('Error in FounderThoughts UI_UX:', e);
            }
        }
    },
    mounted() {
        setTimeout(this.UI_UX, 100);
    }
};
</script>
<style lang="scss">
    .scroll-show-block {
        opacity: 0;
        transform: translateY(28px);
        transition: opacity .7s cubic-bezier(.19,1,.22,1), transform .7s cubic-bezier(.19,1,.22,1);
        &.in-view {
            opacity: 1;
            transform: translateY(0);
        }
    }
    .founder-thoughts {
        position: relative;
        background: #0F1824;
        padding: 100px 20px;
        overflow: hidden;
        &__container {
            width: 100%;
            max-width: 1280px;
            margin: auto;
        }
        &__block {
            display: grid;
            grid-template-columns: 1fr 342px;
            column-gap: 45px;
            align-items: center;
            padding: 55px 0;
            border-top: 1px solid rgba(255, 255, 255, .12);
            &:first-child {
                padding-top: 0;
                border-top: none;
            }
            &:last-child {
                padding-bottom: 0;
            }
        }
        &__content {
            width: 100%;
            h2 {
                font-family: "Cormorant Garamond", serif;
                font-size: 56px;
                line-height: 60px;
                font-weight: 500;
                color: #FFF;
                margin-bottom: 20px;
            }
            h3,
            h4 {
                font-family: "Cormorant Garamond", serif;
                font-weight: 600;
                color: var(--primary);
                letter-spacing: .02em;
            }
            h3 {
                font-size: 30px;
                line-height: 1.25;
                margin: 22px 0 12px;
            }
            h4 {
                font-size: 20px;
                margin: 18px 0 10px;
            }
            p {
                max-width: 920px;
                font-size: 17px;
                line-height: 30px;
                font-weight: 300;
                color: #b9b9b9;
                margin-bottom: 14px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            strong {
                color: #FFF;
                font-weight: 600;
            }
            ul,
            ol {
                max-width: 920px;
                margin: 0 0 14px;
                padding: 0;
                list-style: none;
                counter-reset: founder-thoughts-list;
            }
            li {
                position: relative;
                margin-bottom: 10px;
                padding-left: 26px;
                font-size: 17px;
                line-height: 30px;
                font-weight: 300;
                color: #b9b9b9;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            ul li {
                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: .6em;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: var(--primary);
                }
            }
            ol li {
                counter-increment: founder-thoughts-list;
                &::before {
                    content: counter(founder-thoughts-list) ".";
                    position: absolute;
                    left: 0;
                    color: var(--primary);
                    font-weight: 600;
                }
            }
            @media (max-width:768px) {
                h2 {
                    font-size: 40px;
                    line-height: 46px;
                }
                p {
                    font-size: 16px;
                    line-height: 28px;
                }
            }
        }
        &__tag {
            display: block;
            margin-bottom: 12px;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            text-transform: uppercase;
            color: var(--primary);
        }
        &__divider {
            width: 70px;
            height: 2px;
            background: var(--primary);
            margin-bottom: 22px;
            transition: width .4s ease;
        }
        &-signature {
            width: 200px;
            &-holder {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img {
                    height: auto;
                    display: block;
                }
                p {
                    margin-top: 14px;
                    font-size: 13px;
                    line-height: 1.5;
                    font-weight: 300;
                    font-style: italic;
                    letter-spacing: .02em;
                    color: rgba(255, 255, 255, .5);
                }
            }
        }
        @media (max-width:768px) {
            padding: 60px 20px;
            &__block {
                grid-template-columns: 1fr;
                gap: 25px;
                padding: 45px 0;
            }
            &-signature-holder {
                display: flex;
                justify-content: center;
            }
            &-signature {
                width: 160px;
            }
            &__tag {
                font-size: 11px;
            }
            &__divider {
                width: 55px;
                margin-bottom: 18px;
            }
        }
    }
</style>